import React from "react";
import BottomNav from "@/components/BottomNav";
import EmailReminder from "@/components/EmailReminder";

// Centered mobile viewport on a premium dark field. Admin uses its own layout.
export default function MobileShell({ children, nav = true, className = "" }) {
  return (
    <div className="min-h-screen w-full bg-[#04040c] flex justify-center">
      <div
        className={`relative w-full max-w-[430px] min-h-screen app-bg overflow-hidden flex flex-col ${nav ? "pb-28" : ""} ${className}`}
        style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
      >
        {nav && <EmailReminder />}
        {children}
        {nav && <BottomNav />}
      </div>
    </div>
  );
}
